<template lang="pug">
  e-modal(
    @close="onClose"
    @confirm="saveOptimalSchema"
    title="Оптимальная схема размещения"
    saveBtnLabel="Разместить"
  )
    slot
      .form-group
        label.form-group__label.label Муниципальный район
        e-select.form__elem_input(
          name="geo_object_id"
          inputType="input"
          :model="fields"
          :options="geoObjects"
        )
      .form-group
        label.form-group__label.label Тип моделируемого объекта инфраструктуры *
        e-select.form__elem_input(
          name="object_type"
          inputType="input"
          :model="fields"
          :options="objectsTypes"
        )
      .form-group
        label.form-group__label.label Максимальное расстояние от объекта инфраструктуры (м.)
        e-input.form__elem_input(
          name="max_distance_to_other_objects"
          inputType="input"
          :model="fields"
        )
      .form-group
        label.form-group__label.label Максимальное расстояние от населенного пункта до объекта инфраструктуры (м.)
        e-input.form__elem_input(
          name="max_distance_to_settlement"
          inputType="input"
          :model="fields"
        )
      .form-group
        label.form-group__label.label Максимальное расстояние от МО до объекта инфраструктуры (м.) *
        e-select.form__elem_input(
          name="max_distance_to_road"
          inputType="input"
          :model="fields"
          :options="roadOptions"
          :required='true'
        )
</template>
<script>
import { tko } from '@/api/api-endpoints'
import { REGION_CONFIG } from '@/config/regions'
import L from 'leaflet'
import year from '@/utils/year'

const objectsTypes = [
  {
    id: 'processing',
    name: 'Обработка',
  },
  {
    id: 'neutralization',
    name: 'Обезвреживание',
  },
  {
    id: 'utilization',
    name: 'Утилизация',
  },
  {
    id: 'burial',
    name: 'Захоронение',
  },
]
export default {
  name: 'OptimalSchema',
  props: {
    map: {
      type: Object,
      required: true,
    },
    year: {
      type: Number,
      default: year.getCurrentYear(),
    },
    geoObjects: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      mapCenter: REGION_CONFIG.map,
      fields: {
        geo_object_id: null,
        object_type: 'utilization',
        max_distance_to_other_objects: '',
        max_distance_to_settlement: '',
        max_distance_to_road: '200',
      },
      objectsTypes: objectsTypes,
      objects: [],
      objectsLayer: null,
      roadOptions: [
        { id: 50, name: 50 },
        { id: 100, name: 100 },
        { id: 200, name: 200 },
        { id: 300, name: 300 },
        { id: 400, name: 400 },
        { id: 500, name: 500 },
      ],
    }
  },
  computed: {
    yearOptions() {
      const date = new Date()
      const years = []
      const yearStart = date.getFullYear()
      const yearFinish = yearStart + 10
      for (let i = yearStart; i < yearFinish; i++) {
        years.push({ id: i, name: i })
      }
      return years
    },
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
    setCoords(coords) {
      this.$emit('saveOptimalSchema', coords)
    },
    async saveOptimalSchema() {
      const query = {
        ...this.fields,
        year: this.year,
      }
      this.$bar.start()

      this.objects = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: tko.optimalObjectCoords({
            query,
          }),
        })
      ).data
      this.drawObjects()
      if (this.objects.length) {
        this.$notify.success({
          title: `Объекты размещены`,
        })
      } else {
        this.$notify.warning({
          title: `Не нашлось объектов для размещения`,
        })
      }
      this.$bar.finish()
    },
    removeIcons() {
      this.map.eachLayer((l) => {
        if (
          l?.options?.pane === 'markerPane' ||
          l?.options?.pane === 'overlayPane'
        ) {
          l.remove()
        }
      })
    },
    addContentToObjectPopup(data) {
      return `<div class='map-popup'>
                <div class='map-popup__body'>
                     <div class='map-popup__prop semibold'>Назначение объекта:</div>
                     <div class='map-popup__value'>${data.action.name}</div>
                     <div class='map-popup__prop semibold'>Расстояние до дороги:</div>
                     <div class='map-popup__value'>${data.distance_to_road}</div>
                      <div class='map-popup__prop semibold'>Мощность:</div>
                     <div class='map-popup__value'>${data.power}</div>
                </div>
            </div>
        `
    },
    drawObjects() {
      this.removeIcons()
      this.objectsLayer = L.featureGroup()
      this.objectsLayer.addTo(this.map)
      this.objects.forEach((object) => {
        const iconClassName = `map-icon map-icon_garbage map-icon_optimal map-icon_${object.action.code}`
        const icon = L.divIcon({
          className: 'my-div-icon',
          html: `<div class="${iconClassName}"></div>`,
        })
        const circleLayer = L.circle([object.latitude, object.longitude], {
          radius: 2000,
        })
        const iconLayer = L.marker([object.latitude, object.longitude], {
          icon: icon,
        })
        const popup = L.popup()
        popup.setContent(this.addContentToObjectPopup(object))
        iconLayer.bindPopup(popup)
        iconLayer.addTo(this.objectsLayer)
        circleLayer.addTo(this.objectsLayer)
      })
      this.$emit('close')
    },
  },
}
</script>
